<app-outing-header></app-outing-header>
<router-outlet></router-outlet>
<app-academic-footers></app-academic-footers>